import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPremiumCrown = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 24,
	viewBox: "0 0 19 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M0.652344 2.00231C0.652344 0.898084 1.5475 0.00292969 2.65173 0.00292969V3.00293H0.652344V2.00231Z",
			fill: "#CC8103"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.6434 0.00292969H2.64844V21.1542C2.64844 22.3168 3.98336 22.9728 4.90373 22.2626L9.42409 18.7744C10.1439 18.2189 11.1479 18.2189 11.8678 18.7744L16.3881 22.2626C17.3085 22.9728 18.6434 22.3168 18.6434 21.1542V0.00292969Z",
			fill: "url(#paint0_linear_1_4752)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6454 14.3984H7.70844C7.60786 14.3986 7.50991 14.3654 7.4292 14.3036C7.34849 14.2418 7.28935 14.1549 7.26058 14.0557L5.83676 9.28644C5.80655 9.19386 5.8045 9.09399 5.8309 9.00017C5.8573 8.90636 5.91088 8.82306 5.9845 8.7614C6.05811 8.69975 6.14826 8.66266 6.2429 8.6551C6.33754 8.64754 6.43217 8.66986 6.51415 8.71908L8.47353 10.2263L10.3172 7.49988C10.3335 7.47661 10.353 7.45591 10.3751 7.43844C10.4591 7.36452 10.5659 7.32369 10.6764 7.32324H10.7119C10.773 7.32822 10.8325 7.34553 10.8871 7.37419C10.9417 7.40285 10.9903 7.4423 11.0301 7.49028L12.8812 10.2167L14.8583 8.71908C14.9389 8.68006 15.0286 8.66557 15.1168 8.6773C15.2051 8.68904 15.2883 8.72652 15.3566 8.78532C15.4278 8.84333 15.481 8.92147 15.5097 9.01014C15.5383 9.09882 15.5412 9.19418 15.518 9.28452L14.0923 14.0567C14.0634 14.1555 14.0043 14.2421 13.9238 14.3037C13.8433 14.3653 13.7457 14.3985 13.6454 14.3984Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_1_4752",
			x1: 10.646,
			y1: .00292969,
			x2: 10.646,
			y2: 24.5519,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFD200" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#F7971E"
			})]
		}) })
	]
});
const ForwardRef = forwardRef(SvgPremiumCrown);
export default ForwardRef;
